// src/actions/faultyCount.js
import axios from 'src/utils/axios';

// Action-typer
export const GET_FAULTYCOUNT_REQUEST = 'GET_FAULTYCOUNT_REQUEST';
export const GET_FAULTYCOUNT_SUCCESS = 'GET_FAULTYCOUNT_SUCCESS';
export const GET_FAULTYCOUNT_FAILURE = 'GET_FAULTYCOUNT_FAILURE';

// Thunk för att hämta FaultyCount från API
export const fetchFaultyCount = () => {
  return async (dispatch) => {
    dispatch({ type: GET_FAULTYCOUNT_REQUEST });

    try {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const response = await axios.get(`${baseUrl}/api/faultycount`); 
      // Förväntar JSON som { FaultyMasters: 5 }
      const faultyCountValue = response.data;

      dispatch({
        type: GET_FAULTYCOUNT_SUCCESS,
        payload: faultyCountValue
      });
    } catch (error) {
      console.error('Failed to fetch faulty count:', error);
      dispatch({
        type: GET_FAULTYCOUNT_FAILURE,
        payload: error.message
      });
    }
  };
};